import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

const useDeleteNotificationEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (contactMethodId: string) => {
      await axiosInstance.delete(api.deleteNotificationEmail(contactMethodId));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.client.notificationEmails() });
    },
  });
};

export default useDeleteNotificationEmailMutation;
